import React, {Component} from 'react';
import axios from 'axios'
import {
    SMS_VERIFICATION_SERVER_URL as smsVerificationServerUrl,
    SEND_ENDPOINT as sendEndpoint,
    VERIFY_ENDPOINT as verifyEndpoint,
    MAX_SMS_COUNT as maxSmsCount,
} from './GlobalConfiguration.js';
import {getText} from './util/localization.js'
import '../css/VerificationForm.css';
import {setProperties} from "./util/DefaultProperties";

const queryString = require('query-string');
const localization = require('../localization/localization-verificationForm.json');

class VerificationForm extends Component {

    constructor(props) {
        super(props);

        let queryStringParams = queryString.parse(props.location.search);
        if (queryStringParams === undefined || queryStringParams.smsVerificationId === undefined || queryStringParams.smsVerificationId === '') {
            this.props.history.push('/technicalError');
        }

        setProperties(queryStringParams);


        this.state = {
            smsUUID: queryStringParams.smsVerificationId,
            phoneNumber: '',
            smsCode: '',

            phoneDisabled: false,
            smsCodeHidden: true,
            submitDisabled: true,
            verificationState: 'not_sent',
            buttonText: getText(localization.buttonSendText),
            message: '',
            messageHidden: true,
            resendDisabled: true,
            smsSentCount: 0,

            loaderHidden: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.resend = this.resend.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
    }

    handleChange(e) {
        let name = e.target.name;

        this.setState({
            [name]: e.target.value
        });
    }

    handleNumberChange(e) {
        let name = e.target.name;

        if (!isNaN(Number(e.target.value))) {
            this.setState({
                [name]: e.target.value
            });
        }
    }

    handleSubmit(e) {
        if (this.state.verificationState === 'not_sent') {
            this._sendSms();
        } else if (this.state.verificationState === 'sent') {
            this._verifySms();
        }

        e.preventDefault();
    }

    handleBlur(e) {
        if (e.target.name === "phoneNumber") {
            this._isPhoneValid()
        }
    }

    resend(e) {
        this._isPhoneValid();
        this._sendSms();

        e.preventDefault();
    }

    _sendSms() {
        if (this.state.smsSentCount >= maxSmsCount) {
            console.log("Cannot send more than " + maxSmsCount + " sms");
            this.props.history.push('/expired');
            return;
        }

        this.setState({
            message: '',
            smsSentCount: this.state.smsSentCount + 1,
            loaderHidden: false
        });

        axios.request({
            method: 'post',
            url: '/' + sendEndpoint,
            baseURL: smsVerificationServerUrl,

            data: {
                verificationSessionId: this.state.smsUUID,
                phoneNumber: this.state.phoneNumber
            }
        }).then(response => {
            // TODO parse response status etc
            this.setState({
                verificationState: 'sent',
                buttonText: getText(localization.verifyButtonText),
                smsCodeHidden: false,
                phoneDisabled: true,
                loaderHidden: true
            });

            // allow resend in 10 seconds
            setInterval(() => {
                this.setState({
                    resendDisabled: false
                });
            }, 10000)
        }).catch(error => {
            console.log(error.response.status);
            console.log(error.response.data);
            this.setState({
                message: getText(localization.sendSmsErrorMessage),
                loaderHidden: true
            });
        });
    }

    _verifySms() {
        this.setState({
            message: '',
            loaderHidden: false
        });

        axios.request({
            method: 'post',
            url: '/' + verifyEndpoint,
            baseURL: smsVerificationServerUrl,

            data: {
                verificationSessionId: this.state.smsUUID,
                smsCode: this.state.smsCode
            }
        }).then(response => {
            // TODO parse response status etc
            this.props.history.push('/verified');
        }).catch(error => {
            console.log(error.response.status);
            this.setState({
                message: getText(localization.verifySmsErrorMessage),
                loaderHidden: true
            });
        })
    }

    /**
     * Phone is valid if there is a country code in international format or with plus sign.
     * Examples for german number: +49 123 456 789, 0049 123 456 789.
     * Default country format is not supported (e.g. 0 123 456 789)
     * Format without country code is not supported (e.g. 123 456 789)
     *
     *
     * @returns {RegExpMatchArray}
     * @private
     */
    _isPhoneValid() {
        let regex = "^(?:\\+\\d{1,3}|00\\d{1,2}){1}(?:\\s?\\(\\d+\\))?(?:[-\\/\\s.]|\\d)+$";
        let isValid = this.state.phoneNumber.match(regex);
        let regexCountryCode = "^(?:\\+\\d{1,3}|00\\d{1,2}){1}";
        let containsAllowedCountryCode = this.state.phoneNumber.match(regexCountryCode);

        let errorType = null; //used for determining which error will be thrown

        if (!containsAllowedCountryCode) {
            errorType = 'countryCodeError';
        }

        if (!isValid || !containsAllowedCountryCode) {
            this._showPhoneNumberError(errorType)
        } else {
            this._removePhoneNumberError()
        }

        return isValid;
    }

    _showPhoneNumberError(errorType) {
        let errorMessage;
        if (errorType === 'countryCodeError') {
            errorMessage = getText(localization.showMissingCountryCodeError);
        } else {
            errorMessage = getText(localization.showPhoneNumberError);
        }

        this.setState({
            message: errorMessage,
            messageHidden: false,
            submitDisabled: true
        });
    }

    _removePhoneNumberError() {
        this.setState({
            message: '',
            messageHidden: true,
            submitDisabled: false
        });
    }

    render() {
        return (<div className="container">
            <h1>{getText(localization.title)}</h1>
            <form onSubmit={this.handleSubmit}>
                <div className="form-group" id="phoneNumberFormGroup">
                    <label className="form-control-label" htmlFor="phoneNumber">{getText(localization.phoneNumber)}</label>
                    <input name="phoneNumber" type="tel" value={this.state.phoneNumber}
                           disabled={this.state.phoneDisabled} className="form-control" aria-describedby="phoneNumber"
                           onChange={this.handleChange} onBlur={this.handleBlur}/>
                </div>

                <div className="form-group" hidden={this.state.smsCodeHidden}>
                    <label className="form-control-label" htmlFor="smsCode">{getText(localization.smsCodeLabel)}</label>
                    <input name="smsCode" type="text" minLength="1" maxLength="9" value={this.state.smsCode} className="form-control"
                           aria-describedby="smsCode" onChange={this.handleNumberChange} onBlur={this.handleBlur}/>
                </div>

                <p className="alert-danger">{this.state.message}</p>

                <input disabled={this.state.submitDisabled} className="btn btn-primary btn-block" type="submit"
                       value={this.state.buttonText}/>

                <input disabled={this.state.resendDisabled} hidden={this.state.resendDisabled}
                       className="btn btn-primary btn-block" type="button" value={getText(localization.buttonResendText)} onClick={this.resend}/>
            </form>
            <div className="loaderContainer" hidden={this.state.loaderHidden}>
                <div className="loader"/>
            </div>
        </div>);
    }
}

export default VerificationForm;



// WEBPACK FOOTER //
// ./src/js/VerificationForm.js